import * as THREE from "three";
import { LineGeometry } from "three/addons/lines/LineGeometry.js";
import { LineMaterial } from "three/addons/lines/LineMaterial.js";
import { Line2 } from "three/addons/lines/Line2.js";
// import {OrbitControls} from "three/addons/controls/OrbitControls.js";
// === Scene Setup ===
const scene = new THREE.Scene();
const can = document.querySelector(".cust-star");
const camera = new THREE.PerspectiveCamera(45, can.clientWidth / can.clientHeight, 0.1, 100);
camera.position.set(0, 0, 5);
const renderer = new THREE.WebGLRenderer({
    canvas: can,
    antialias: true
});
renderer.setSize(window.innerWidth, window.innerHeight, false);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.setClearColor(0xffffff,0);
// === Star Shape ===
const outerRadius = 1.8;
const innerRadius = 0.51;
const pointsCount = 5;
const star2DPoints = [];
for (let i = 0; i < pointsCount * 2; i++) {
    const angle = (i * Math.PI) / pointsCount;
    const radius = (i % 2 === 0) ? outerRadius : innerRadius;
    const x = Math.cos(angle) * radius;
    const y = Math.sin(angle) * radius;
    star2DPoints.push(new THREE.Vector2(x, y));
}
// --- Create smooth curve for star outline ---
const curvePoints = star2DPoints.map(p => new THREE.Vector3(p.x, p.y, 0));
const smoothCurve = new THREE.CatmullRomCurve3(curvePoints, true, "catmullrom", 0.1);
const smoothPointsCount = 100;
const smoothPoints = smoothCurve.getPoints(smoothPointsCount);
const smoothPositions = [];
smoothPoints.forEach(p => {
    smoothPositions.push(p.x, p.y, p.z);
});
// === Star Line (Outline) with smooth points ===
const lineGeometry = new LineGeometry();
lineGeometry.setPositions(smoothPositions);
const lineMaterial = new LineMaterial({
    color: 0xffff00,
    linewidth: 0,
});
lineMaterial.resolution.set(window.innerWidth, window.innerHeight);
const starLine = new Line2(lineGeometry, lineMaterial);
starLine.computeLineDistances();
scene.add(starLine);    
// === Particle Setup ===
const particleGeometry = new THREE.SphereGeometry(0.0096);
const edgeParticleMaterial = new THREE.MeshBasicMaterial({
    color: 0xff6600,
    emissive: 0xff6600,
    transparent: true,
    opacity: 1,
});
const innerParticleMaterial = new THREE.MeshBasicMaterial({
    color: 0xff6600,
    emissive: 0xff8800,
    transparent: true,
    blending: THREE.AdditiveBlending,
    opacity: 0.2,
});
const particlesGroup = new THREE.Group();
scene.add(particlesGroup);
function randomBetween(min, max) {
    return Math.random() * (max - min) + min;
}
function isPointInPolygon(point, polygon) {
    let inside = false;
    const x = point.x;
    const y = point.y;
 
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x, yi = polygon[i].y;
        const xj = polygon[j].x, yj = polygon[j].y;
 
        const intersect = ((yi > y) !== (yj > y)) &&
            (x < (xj - xi) * (y - yi) / ((yj - yi) || 0.00001) + xi);
        if (intersect) inside = !inside;
    }
 
    return inside;
}
// === Particles ===
const edgeParticles = [];
const innerParticles = [];
// 1. Edge Particles (distributed along smooth curve)
const edgeParticleCount = 2000;
for (let i = 0; i < edgeParticleCount; i++) {
    const particle = new THREE.Mesh(particleGeometry, edgeParticleMaterial);
    // Random position along smooth curve [0..1]
    const t = Math.random();
    const pos = smoothCurve.getPoint(t);
    const offsetX = randomBetween(-0.03, 0.03);
    const offsetY = randomBetween(-0.03, 0.03);
    const offsetZ = randomBetween(-0.3, 0.3);
 
    particle.position.set(pos.x + offsetX, pos.y + offsetY, pos.z + offsetZ);
    particle.userData.basePosition = particle.position.clone();
    particle.userData.targetOffset = new THREE.Vector3();
 
    particlesGroup.add(particle);
    edgeParticles.push(particle);
}
// 2. Inner Particles
const fillParticleCount = 5000;
const boundingRadius = outerRadius;
for (let i = 0; i < fillParticleCount; i++) {
    let x, y, found = false, attempts = 0;
    while (!found && attempts < 100) {
        x = randomBetween(-boundingRadius, boundingRadius);
        y = randomBetween(-boundingRadius, boundingRadius);
        const point = new THREE.Vector2(x, y);
        if (isPointInPolygon(point, star2DPoints)) {
            found = true;
        }
        attempts++;
    }
    if (found) {
        const z = randomBetween(-0.1, 0.1);
        const particle = new THREE.Mesh(particleGeometry, innerParticleMaterial);
        particle.position.set(x, y, z);
        particle.userData.basePosition = particle.position.clone();
        particle.userData.targetOffset = new THREE.Vector3();
        particlesGroup.add(particle);
        innerParticles.push(particle);
    }
}
// === Raycaster + Mouse Setup ===
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();
let isMouseOverCanvas = false;
can.addEventListener("mouseenter", () => {
    isMouseOverCanvas = true;
});
can.addEventListener("mouseleave", () => {
    isMouseOverCanvas = false;
    [...edgeParticles, ...innerParticles].forEach(p => {
        p.userData.targetOffset.set(0, 0, 0);
    });
});
can.addEventListener("mousemove", (event) => {
    const rect = can.getBoundingClientRect();
    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
});
function updateMousePosition(x, y) {
    const rect = can.getBoundingClientRect();
    mouse.x = ((x - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((y - rect.top) / rect.height) * 2 + 1;
}
can.addEventListener("mousemove", (event) => {
    updateMousePosition(event.clientX, event.clientY);
});
can.addEventListener("touchstart", (event) => {
    isMouseOverCanvas = true;
    if (event.touches.length > 0) {
        updateMousePosition(event.touches[0].clientX, event.touches[0].clientY);
    }
}, { passive: true });
can.addEventListener("touchmove", (event) => {
    if (event.touches.length > 0) {
        updateMousePosition(event.touches[0].clientX, event.touches[0].clientY);
    }
}, { passive: true });
can.addEventListener("touchend", () => {
    isMouseOverCanvas = false;
    [...edgeParticles, ...innerParticles].forEach(p => {
        p.userData.targetOffset.set(0, 0, 0);
    });
});
// Trigger mouse hover on load
document.addEventListener("DOMContentLoaded", () => {
    const rect = can.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    mouse.x = ((centerX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((centerY - rect.top) / rect.height) * 2 + 1;
    isMouseOverCanvas = true;
});
starLine.rotation.z = -0.94;        
particlesGroup.rotation.z =- 0.94;
// === Animation Loop ===
const pointer3D = new THREE.Vector3();
let lastValidPointer = new THREE.Vector3();
// === controls ===
function placeStarTopRight() {
    // NDC coordinates for top-right corner
    const ndcX = 1;   // Right edge
    const ndcY = 1;   // Top edge
 
    // Use z=0.5 for middle between near and far clipping planes
    const vector = new THREE.Vector3(ndcX, ndcY, 0.5);
    vector.unproject(camera);
 
    // Place star on z=0 plane for consistency
    vector.z = 0;
 
    // Set star position
    starLine.position.copy(vector);
    particlesGroup.position.copy(vector);
}
 
// Call once after setup to position star
placeStarTopRight();
function animate(time = 0) {
    // controls.update();
    const t = time * 0.001;
    const cycleDuration = 10;
    const disperseDuration = 6;
    const cycleTime = t % cycleDuration;
    const starCenter = new THREE.Vector3(0, 0, 0);
    const boundaryRadius = 2.5;
    // Keep rotation consistent
    const rotationZ = 0.16 + t * 0.02;
    // starLine.rotation.z = rotationZ;
    // particlesGroup.rotation.z = 0;
 
    if (isMouseOverCanvas) {
        raycaster.setFromCamera(mouse, camera);
        const planeZ = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);
        raycaster.ray.intersectPlane(planeZ, pointer3D);
    }
 
    [...edgeParticles, ...innerParticles].forEach((p, idx) => {
        if (!p.userData.velocity) {
            p.userData.velocity = new THREE.Vector3(
                (Math.random() - 0.5) * 0.003,
                (Math.random() - 0.5) * 0.003,
                (Math.random() - 0.5) * 0.003
            );
        }
 
        const base = p.userData.basePosition;
 
        if (cycleTime < disperseDuration) {
            // Disperse Phase
            const noiseStrength = 0.001;
            p.userData.velocity.x += (Math.sin(t * 8 + idx) - 0.5) * noiseStrength;
            p.userData.velocity.y += (Math.cos(t * 9 + idx * 1.3) - 0.5) * noiseStrength;
            p.userData.velocity.z += (Math.sin(t * 7 + idx * 0.7) - 0.5) * noiseStrength;
 
            p.userData.velocity.y += 0.0015; // upward float
 
            const toCenter = p.position.clone().sub(starCenter).normalize();
            const swirl = new THREE.Vector3(-toCenter.z, 0, toCenter.x).multiplyScalar(0.004);
            p.userData.velocity.add(swirl);
 
            // Magnetic attraction
            let attractPoint = isMouseOverCanvas ? pointer3D : starCenter;
            const toAttract = attractPoint.clone().sub(p.position);
            const dist = toAttract.length();
 
            if (dist > 0.3) {
                const attractionStrength = 0.002 * (dist / boundaryRadius);
                p.userData.velocity.add(toAttract.normalize().multiplyScalar(attractionStrength));
            }
 
            // Soft boundary
            if (p.position.distanceTo(starCenter) > boundaryRadius) {
                const fromCenter = p.position.clone().sub(starCenter).normalize();
                p.userData.velocity.add(fromCenter.multiplyScalar(-0.015));
            }
 
            p.userData.velocity.multiplyScalar(0.92);
            p.position.add(p.userData.velocity);
 
        } else {
            // Return Phase — back to base
            const toBase = base.clone().sub(p.position);
            const distanceToBase = toBase.length();
            const normalizedReturnTime = (cycleTime - disperseDuration) / (cycleDuration - disperseDuration);
            const easeOut = 1 - Math.pow(1 - normalizedReturnTime, 3);
            const returnSpeed = THREE.MathUtils.clamp(easeOut * 0.12, 0.01, 0.2);
            p.position.lerp(base, returnSpeed);
 
            p.userData.velocity.multiplyScalar(0.7);
 
            // Snap exactly to base if very close
            if (distanceToBase < 0.005) {
                p.position.copy(base);
            }
 
            // Optional: add motion only if not too close to base
            if (distanceToBase >= 0.005) {
                const oscillationAmplitude = 0.001;
                const oscillation = new THREE.Vector3(
                    Math.sin(t * 5 + idx) * oscillationAmplitude,
                    Math.cos(t * 4 + idx * 1.3) * oscillationAmplitude,
                    Math.sin(t * 6 + idx * 0.7) * oscillationAmplitude * 0.6
                );
 
                const swirlRadius = 0.001;
                const swirl = new THREE.Vector3(
                    Math.cos(t * 3 + idx) * swirlRadius,
                    Math.sin(t * 2 + idx * 1.5) * swirlRadius,
                    Math.sin(t * 4 + idx) * swirlRadius * 0.5
                );
 
                p.position.add(oscillation).add(swirl);
            }
        }
    });
    renderer.render(scene, camera);
    requestAnimationFrame(animate);
}
window.addEventListener("resize", function() {
    camera.aspect = can.clientWidth / can.clientHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight, false);
});
animate();